/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".material-icons[_ngcontent-%COMP%]{margin:.2rem;cursor:pointer;color:#070b36}.material-icons[_ngcontent-%COMP%]:hover{color:#26eeae}"];
export { styles as styles };
